{
  "title": "Revenue",
  "menu": "Revenue",
  "orderContext": "Order-scoped revenue context",
  "sourceCount": "{{count}} revenue entries returned by accounting",
  "priorityMetrics": "Priority metrics",
  "kpi": {
    "netProfit": "Net Profit",
    "roi": "Return on Investment",
    "collectionRate": "Revenue Collection Rate",
    "freeCashFlow": "Free Cash Flow",
    "basisNote": "{{basisNote}}",
    "unavailable": "Not available for this order",
    "freeCashFlowContext": "No separate capex entry is included in this revenue model; FCF is shown as supplied."
  },
  "error": {
    "title": "Unable to Load Revenue Data",
    "message": "An error occurred while fetching revenue accounting data. Please try again.",
    "retry": "Try Again"
  },
  "missing": {
    "title": "Order Not Found",
    "message": "No order accounting data found. Please go back and select a valid order.",
    "back": "Go Back"
  },
  "noData": {
    "title": "No Revenue Data Yet",
    "message": "Revenue accounting entries have not been generated for this order. This typically occurs when the accounting worker has not yet processed this transaction, or the transaction ID (tcId) was not available."
  },
  "metric": {
    "revenueInvoiced": "Revenue Invoiced (accrued)",
    "revenueCollected": "Revenue Collected (cash)",
    "cashConversionContext": "Cash conversion is shown as a percentage from the model."
  },
  "group": {
    "executive": {
      "title": "Executive metrics",
      "subtitle": "Yield, liquidity, balance-sheet position, and operating efficiency."
    },
    "derived": {
      "title": "Derived metrics",
      "subtitle": "Profitability, collection, return, and working-capital indicators supplied by accounting."
    },
    "base": {
      "title": "Base metrics",
      "subtitle": "Recorded revenue and cost amounts. Invoiced is accrual; collected is cash."
    }
  },
  "reconciliation": {
    "title": "Reconciliation",
    "subtitle": "Reference equations clarify cash versus accrual values; nothing is recomputed here.",
    "equals": "Equals",
    "plus": "Plus",
    "minus": "Minus",
    "unavailable": "Not available for this order"
  },
  "table": {
    "title": "Revenue detail",
    "subtitle": "All 23 revenue accounting entries, auditable reference",
    "ariaLabel": "Title company revenue metrics",
    "caption": "Title Company Revenue Metrics",
    "posted": "Posted",
    "unposted": "Unposted",
    "override": "Override applied",
    "overrideShort": "Override",
    "months": "months",
    "month": "month",
    "unavailable": "Not available for this order",
    "col": {
      "code": "Code",
      "description": "Description",
      "group": "Group",
      "amount": "Amount",
      "date": "Date",
      "context": "Context"
    }
  },
  "groupLabels": {
    "base": "Base",
    "derived": "Derived",
    "executive": "Executive"
  },
  "equations": {
    "revenueInvoicedLabel": "Revenue Invoiced (accrued)",
    "revenueCollectedLabel": "Revenue Collected (cash)",
    "revenuePendingLabel": "Revenue Pending",
    "costsIncurredLabel": "Costs Incurred",
    "costsSettledLabel": "Costs Settled",
    "costsOpenLabel": "Costs Open",
    "netProfitLabel": "Net Profit",
    "currentAssetsLabel": "Current Assets"
  },
  "statesLegacy": {
    "errorTitle": "Unable to Load Revenue Data"
  }
}
